export default __webpack_public_path__ + "static/media/Versions - Comparisons_06.34862f87.jpg";